module.exports = __webpack_public_path__ + "static/media/iran6.6a09648c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/iran6.jpg
// module id = 259
// module chunks = 0